import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      height: 84,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      border: theme.shape.borderGray80,
      borderRadius: theme.shape.borderRadiusMedium,
      '&:hover': {
        backgroundColor: COLORS.neutral.white,
        boxShadow: theme.shape.boxShadowMedium,
      },
      boxShadow: theme.shape.boxShadowNormal,
    },
    label: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    title: {
      color: COLORS.gray.black,
      marginTop: theme.spacing(1.5),
    },
  }),
  { name: 'MenuCard' }
);
